import { render, staticRenderFns } from "./PostingInput.vue?vue&type=template&id=7ba35574&"
import script from "./PostingInput.vue?vue&type=script&lang=js&"
export * from "./PostingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports